import { serverSideCriteriaProcessing } from '@openx/components-table/serverSideCriteriaProcessing.ts';
import type { Segment_Bool_Exp, Segment_Order_By } from '@openx/types/gqlTypes.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { adjustCriteriaFilters } from './adjustCriteriaFilters.ts';
import { defaultSegmentsCriteria, type SegmentsListFilters } from './defaultSegmentsCriteria.ts';

const SEGMENTS_LIST_BASE_FILTERS: Segment_Bool_Exp[] = [
  { category: { _eq: 'direct' } },
  { is_leaf: { _eq: true } },
  { is_archived: { _eq: false } },
];

type BuildSegmentsListQueryVariablesParams = {
  criteria: AllTableCriteria<SegmentsListFilters>;
  accountId?: string | null;
  restrictToAccount?: boolean;
};

export type SegmentsListQueryVariables = {
  /** Where clause for GetSegmentsList / GetSegmentsTotal ($where is wrapped with base filters in GQL). */
  listWhere: Segment_Bool_Exp;
  /** Full where clause for ExportSegmentsList (no GQL wrapping). */
  exportWhere: Segment_Bool_Exp;
  order_by?: Segment_Order_By | Segment_Order_By[];
};

export const buildSegmentsListQueryVariables = ({
  criteria,
  accountId,
  restrictToAccount = false,
}: BuildSegmentsListQueryVariablesParams): SegmentsListQueryVariables => {
  const queryFilters = adjustCriteriaFilters(criteria);
  const queryCrit = serverSideCriteriaProcessing({ ...criteria, filters: queryFilters }, [
    defaultSegmentsCriteria.sort,
  ]);

  const listWhere = {
    ...(queryCrit.where || {}),
    ...(restrictToAccount && accountId ? { account_id: { _eq: accountId } } : {}),
  } as Segment_Bool_Exp;

  return {
    listWhere,
    exportWhere: {
      _and: [...SEGMENTS_LIST_BASE_FILTERS, listWhere],
    },
    order_by: (queryCrit.order_by ?? undefined) as Segment_Order_By | Segment_Order_By[] | undefined,
  };
};
